import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';

import type { GetMarketingResponse } from './types';

export const getMarketing = async (lang = 'en') => {
    const search = window.location.search;
    const queryParams = [`culture=${lang}`];
    if (search) queryParams.push(search.slice(1));

    return fetch(`${PUBLIC_IDM_API_URL_ENV}/marketing?${queryParams.join('&')}`, {
        method: 'GET',
        credentials: 'include',
    })
        .then((res) => {
            if (res.ok) return res.json() as Promise<GetMarketingResponse>;
        })
        .catch((error) => {
            console.error('Error 500 request error: ', error);
            throw error;
        });
};
